// Our own beautiful body lock package 🔒

class bodyLock {
  /**
   * lock the body to prevent scrolling.
   */
  lock() {
    const bodyElement = document.querySelector('body')

    bodyElement.classList.add('js-scroll-lock')
  }

  /**
   * unlock the scrolling of the body.
   */
  unlock() {
    const bodyElement = document.querySelector('body')

    bodyElement.classList.remove('js-scroll-lock')
  }
}

export default new bodyLock()
